export default "__VITE_ASSET__CdeA27Jb__"